export class GcpSourceAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "folderId",
            "baseName": "folderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "optionalCapabilities",
            "baseName": "optionalCapabilities",
            "type": "GcpOptionalCapabilities",
            "format": ""
        },
        {
            "name": "services",
            "baseName": "services",
            "type": "GcpSourceServices",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
